import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {materialsForClientAction} from '../../../actions/materialAction';
import {materialError} from '../../materials/utils/materialError';

/**
 * Материалы ступени, на которой клиентка сейчас, — в её карточке.
 *
 * Куратор видит два ответа сразу: что она проходит и что уже изучила. Без
 * этого он присылает второй раз посмотренное вчера, и разговор начинается с
 * «я это видела».
 *
 * Рядом с каждым материалом стоит плейсхолдер — то, что вставляют в сообщение,
 * чтобы клиентке ушла карточка. Держать эти имена в голове куратор не обязан.
 */
export function ClientMaterials({client}) {
  const dispatch = useDispatch();
  const [stage, setStage] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  const getList = useCallback(() => {
    if (!client || !client.id) {
      return;
    }
    setLoaded(false);
    dispatch(materialsForClientAction(client.id)).then((data) => {
      setStage(data && data.stage ? data.stage : null);
      setMaterials(data && Array.isArray(data.materials) ? data.materials : []);
      setLoaded(true);
    }).catch((e) => {
      setLoaded(true);
      toast.error(materialError(e), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch, client]);

  useEffect(() => {
    getList();
  }, [getList]);

  const studiedCount = materials.filter((m) => m.studied).length;

  return <div className="user-info__wrapper">
    <p className="help">Материалы{stage ? ' · ступень «' + stage.title + '»' : ''}</p>
    <span className="user-info__text">
      {!loaded && 'загружаются…'}
      {loaded && !materials.length && (stage ? 'к этой ступени пока нет' : 'ступень не определена')}
      {loaded && !!materials.length && 'изучено ' + studiedCount + ' из ' + materials.length}
    </span>
    {!!materials.length && <span className="dropdown--link pointer" style={{display: 'block', marginTop: '6px'}}
                                 onClick={() => setOpen((value) => !value)}>
      {open ? 'Свернуть' : 'Показать'}
    </span>}

    {open && <div style={{marginTop: '8px'}}>
      {materials.map((material) => <div key={material.id} style={{padding: '4px 0'}}>
        <span>{material.title}</span>
        <span className="user-info__status" style={{marginLeft: '6px'}}>
          {material.kind === 'video' ? 'видеозапись' : 'пособие'}
        </span>
        {/* Отметку ставит сама клиентка на экране материала: это её слова
            куратору, а не счётчик просмотра */}
        <span className={'user-info__status ' + (material.studied ? 'user-info__status--active' : '')}
              style={{marginLeft: '6px'}}>
          {material.studied ? 'изучено' : 'ещё не изучено'}
        </span>
        {/* Вставляется в сообщение — клиентке уйдёт карточка материала */}
        {material.placeholder && <div className="help" style={{marginTop: '2px'}}>{material.placeholder}</div>}
      </div>)}
    </div>}
  </div>;
}
